export const dateFormulationForModal = (dateString, needTime) => {
  let gmtTime = new Date(dateString);
  let estTime = new Date(gmtTime - 5 * 60 * 60 * 1000);
  estTime = estTime.toISOString();
  // const dateStr = dateString;
  const mm = estTime.slice(5, 7);
  const dd = estTime.slice(8, 10);
  const yyyy = estTime.slice(0, 4);
  const time = estTime.slice(11, 19);
  const date = new Date(yyyy, mm - 1, dd);
  const nameOfDay = date.toLocaleString('en-us', { weekday: 'long' });
  const nameOfMonth = date.toLocaleString('default', {
    month: 'long',
  });
  if (needTime) return `${time} ${nameOfDay}, ${nameOfMonth}  ${dd}, ${yyyy}`;
  return `${nameOfDay}, ${nameOfMonth}  ${dd}, ${yyyy}`;
};